<template>
  <div>
    <el-row>
      <el-button size="medium" @click="addCar">新增</el-button>
    </el-row>
    <el-row style="margin-top:10px">
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="LICENSE_PLATE" label="车牌号" width="100"></el-table-column>
          <el-table-column prop="DRIVER" label="联系人" width="200"></el-table-column>
          <el-table-column prop="CELLPHONE" label="联系电话" width="200"></el-table-column>
          <el-table-column prop="address" label="车辆位置"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="modify(scope.row)">修改</el-button>
              <el-button type="text" style="color:#CC3333" @click="isRefuseUse(scope.row)" v-if="scope.row.STATUS == 1">
                禁用
              </el-button>
              <el-button type="text" @click="isUse(scope.row)" v-if="scope.row.STATUS == 0">启用</el-button>
              <el-button type="text" @click="deleteCar(scope.row)">删除</el-button>
              <el-button type="text" @click="pushToAccount(scope.row)">账号管理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增车辆" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm">
        <el-form-item label="车牌号码：" :label-width="formLabelWidth">
          <el-input v-model="addForm.LICENSE_PLATE" placeholder="请输入车牌号码"></el-input>
        </el-form-item>
        <el-form-item label="司机姓名：" :label-width="formLabelWidth">
          <el-input v-model="addForm.DRIVER" placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item label="司机手机号：" :label-width="formLabelWidth">
          <el-input v-model="addForm.CELLPHONE" placeholder="请输入司机手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click.native="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改车辆" center :visible.sync="modifyFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="modifyForm" ref="modifyForm">
        <el-form-item label="车牌号码：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.LICENSE_PLATE" placeholder="请输入车牌号码"></el-input>
        </el-form-item>
        <el-form-item label="司机姓名：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.DRIVER" placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item label="司机手机号：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.CELLPHONE" placeholder="请输入司机手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="modifyFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入loader
import AMapLoader from '@amap/amap-jsapi-loader';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      addFormVisible: false,
      modifyFormVisible: false,
      modifyForm: {},
      addForm: {},
      formLabelWidth: '100px',
      carMsg: {},
      lnglats: [],
      // reg1: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/,
      geocoder: '',
      address: [],
    };
  },
  created() {
    AMapLoader.load({
      key: '34dc75c9a73045351c1bfdf86f1d853d', // 申请好的Web端开发者Key，首次调用 load 时必填
      version:
        '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.Geocoder'], // 插件列表
    }).then((AMap) => {
      this.geocoder = new AMap.Geocoder();
      this.getAllCarList();
    });
  },
  methods: {
    // 禁用
    isRefuseUse(row) {
      this.$confirm('是否禁用该车辆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10061',
          OTYPE: 5,
          CAR_ID: row.ID,
          STATUS: 0,
        };
        http.post(params).then((_result) => {
          this.getAllCarList();
          this.$message.show({ text: '禁用成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    // 启用
    isUse(row) {
      this.$confirm('是否启用该车辆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10061',
          OTYPE: 5,
          CAR_ID: row.ID,
          STATUS: 1,
        };
        http.post(params).then((_result) => {
          this.getAllCarList();
          this.$message.show({ text: '启用成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    // 删除
    deleteCar(row) {
      this.$confirm('是否删除该车辆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '12011',
          OTYPE: 4,
          CAR_ID: row.CAR_ID,
        };
        http.post(params).then((_result) => {
          this.getAllCarList();
          this.$message.show({ text: '删除成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    // 修改
    modify(row) {
      this.carMsg = row;
      this.$set(this.modifyForm, 'LICENSE_PLATE', row.LICENSE_PLATE);
      this.$set(this.modifyForm, 'DRIVER', row.DRIVER);
      this.$set(this.modifyForm, 'CELLPHONE', row.CELLPHONE);
      this.modifyFormVisible = true;
    },
    // 修改确认
    submitModify() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 3,
        CAR_ID: this.carMsg.CAR_ID,
      };
      if (this.modifyForm.LICENSE_PLATE != this.carMsg.LICENSE_PLATE) {
        params.LICENSE_PLATE = this.modifyForm.LICENSE_PLATE;
      }
      if (this.modifyForm.DRIVER != this.carMsg.DRIVER) {
        params.DRIVER = this.modifyForm.DRIVER;
      }
      if (this.modifyForm.CELLPHONE != this.carMsg.CELLPHONE) {
        params.CELLPHONE = this.modifyForm.CELLPHONE;
      }
      if (!this.validate(this.modifyForm.LICENSE_PLATE, this.modifyForm.CELLPHONE)) {
        return false;
      }
      http.post(params).then((_result) => {
        this.getAllCarList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.modifyFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取所有车辆
    getAllCarList() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 2,
        COMPANY_ID: sessionStorage.getItem('tcId'),
        COMPANY_TYPE: 2,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
          this.lnglats = [];
          result.forEach((item) => {
            this.lnglats.push(item.CURRENT_LOCATION);
          });
          this.getAddresses();
        } else {
          this.tableData = [];
          this.lnglats = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增确认
    submitAdd() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 1,
        COMPANY_ID: sessionStorage.getItem('tcId'),
        COMPANY_TYPE: 2,
      };
      if (this.addForm.LICENSE_PLATE) {
        params.LICENSE_PLATE = this.addForm.LICENSE_PLATE;
      } else {
        this.$message.show({ text: '必须填入车牌号码', type: 'warning' });
        return false;
      }
      if (this.addForm.DRIVER) {
        params.DRIVER = this.addForm.DRIVER;
      } else {
        this.$message.show({ text: '必须填入司机姓名', type: 'warning' });
        return false;
      }
      if (this.addForm.CELLPHONE) {
        params.CELLPHONE = this.addForm.CELLPHONE;
      } else {
        this.$message.show({ text: '必须填入司机手机号', type: 'warning' });
        return false;
      }
      if (!this.validate(params.LICENSE_PLATE, params.CELLPHONE)) {
        return false;
      }
      http.post(params).then((_result) => {
        this.getAllCarList();
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增弹框确认
    addCar() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    // 跳转
    pushToAccount(row) {
      this.$router.push({ path: `accountManagement/${row.CAR_ID}`, params: { id: row.CAR_ID } });
    },
    // 获取地址
    getAddresses() {
      this.geocoder.getAddress(this.lnglats, (status, result) => {
        if (status === 'complete' && result.regeocodes.length) {
          this.tableData.forEach((item, index) => {
            this.$set(item, 'address', result.regeocodes[index].formattedAddress);
          });
        }
      });
    },
    // 验证车牌号、手机号
    validate(str1, str2) {
      if (!validation.手机号验证(str2)) {
        this.$message.show({ text: '输入的手机号格式不正确，请重新输入', type: 'warning' });
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/carSet.vue